export default __webpack_public_path__ + "457f540baf8cf062ce8d88ae1dcfec91.svg";